import * as Sentry from "@sentry/react";
import sentryConfigService, { SentryDynamicConfig } from "./services/sentry-config-service";
import packageJson from './package.json';

Sentry.init({
  dsn: "https://50fb24641cc3f7bf2bc72e6e2fc0cab5@o4510787235545088.ingest.de.sentry.io/4511256866062416", 
  sendDefaultPii: true,
  release: `ServCraftWeb@${packageJson.version}`,
  environment: import.meta.env.MODE ?? 'development',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
    ...(Sentry.consoleLoggingIntegration
      ? [Sentry.consoleLoggingIntegration({ levels: ['warn', 'error'] })]
      : []),
    ...(Sentry.featureFlagsIntegration
      ? [Sentry.featureFlagsIntegration()]
      : []),
  ],
  tracesSampler: SentryDynamicConfig.tracesSampler,
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/.*\.servcraft\.co\.za\/api/,
  ],
  // Replay only on errors: never record plain sessions, always record the
  // buffered minute before an error (Sentry's recommended errors-only setup).
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
  beforeSend: SentryDynamicConfig.beforeSend,
  beforeSendTransaction: SentryDynamicConfig.beforeSendTransaction,
  // v10 removed `_experiments.enableLogs` / `_experiments.beforeSendLog`.
  // `enableLogs` is still backfilled from `_experiments`, but `beforeSendLog`
  // is not — it must be top-level or it is never invoked.
  enableLogs: true,
  beforeSendLog: (log) => {
    if (!sentryConfigService.isEnabled()) return null;
    if (!sentryConfigService.shouldCaptureLogLevel(log.level)) return null;
    return log;
  },
});
